import { createSelector } from '@ngrx/store';

import { SolutionAllowedTypes, TransactionSolution } from '@shared/models';

import { transactionSolution } from './transaction-solution.reducer';

export const { selectEnabledSolutionConfigs, selectEnabledSolutions } = transactionSolution;

export const selectSolutionByName = (solutionName: TransactionSolution) =>
  createSelector(selectEnabledSolutionConfigs, (configs) => configs?.find((item) => item.solutionName === solutionName));

export const selectSolutionCurrency = (solutionName: TransactionSolution) =>
  createSelector(selectSolutionByName(solutionName), (solution) => {
    return solution?.solutionConfig?.allowedCurrencies?.[0] || 'USD';
  });

export const selectTransactionTypes = (type: 'debit' | 'credit') =>
  createSelector(
    selectEnabledSolutionConfigs,
    (configs) =>
      configs?.reduce((obj: SolutionAllowedTypes, { solutionName, solutionConfig: { transactionTypes } }) => {
        const { SEND, REQUEST, RETURN, REVERSAL, ADJUSTMENT } = transactionTypes;
        return {
          ...obj,
          [solutionName]: {
            ...(SEND && { SEND: SEND.allowedAccountTypes?.[type] }),
            ...(REQUEST && { REQUEST: REQUEST.allowedAccountTypes?.[type] }),
            ...(RETURN && { RETURN: RETURN.allowedAccountTypes?.[type] }),
            ...(REVERSAL && { REVERSAL: REVERSAL.allowedAccountTypes?.[type] }),
            ...(ADJUSTMENT && { ADJUSTMENT: ADJUSTMENT.allowedAccountTypes?.[type] }),
          },
        };
      }, {}) ?? {},
  );
